import gql from 'graphql-tag';

export const CREATE_FAQ_CATEGORY = gql`
  mutation CreateFaqCategory($input: FaqCategoryInput!) {
    createFaqCategory(input: $input) {
      name
    }
  }
`;

export const CREATE_FAQ = gql`
  mutation CreateFaq($input: FaqInput!) {
    createFaq(input: $input) {
      _id
    }
  }
`;

export const UPDATE_FAQ = gql`
  mutation UpdateFaq($faq: MOID!, $input: FaqInput!) {
    updateFaq(faq: $faq, input: $input)
  }
`;

export const DELETE_FAQ = gql`
  mutation DeleteFaq($faqId: MOID!) {
    deleteFaq(faq: $faqId)
  }
`;
